import { render, staticRenderFns } from "./BuyBusiness.vue?vue&type=template&id=ed9caae8&scoped=true&"
import script from "./BuyBusiness.vue?vue&type=script&lang=js&"
export * from "./BuyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./BuyBusiness.vue?vue&type=style&index=0&id=ed9caae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9caae8",
  null
  
)

export default component.exports